import React from 'react';
import cx from 'classnames';

import styles from './Tabs.module.scss';

const Tabs = ({ children, className, withPanel = false }) => {
    return (
        <ul className={cx(className, styles.tabs, {[styles.tabsWithPanel] : withPanel} )}>
            {children}
        </ul>
    )
}

export default Tabs;
